import api from '@pray/shared/utils/api';

export type InvoiceDerivedStatus = 'open' | 'overdue' | 'paid' | 'partially_paid' | 'void' | 'written_off';

export type PaymentView = {
  id: string;
  invoice_id: string;
  external_payment_id: string | null;
  amount_cents: number;
  currency: string;
  paid_at: string;
  method: string | null;
  memo: string | null;
  source: string;
  created_at: unknown;
  updated_at: unknown;
};

export type InvoiceWithState = {
  id: string;
  contract_id: string;
  external_invoice_id: string;
  amount_cents: number;
  currency: string;
  issue_date: string | null;
  due_date: string;
  lifecycle_status: 'open' | 'void' | 'written_off';
  memo: string | null;
  source: string;
  created_at: unknown;
  updated_at: unknown;
  payments: PaymentView[];
  status: InvoiceDerivedStatus;
  amount_paid_cents: number;
  balance_cents: number;
  days_overdue: number;
};

export type ReceivablesSummary = {
  total_billed_cents: number;
  total_paid_cents: number;
  outstanding_balance_cents: number;
  count_due: number;
  count_overdue: number;
  max_days_overdue: number;
  next_due_date: string | null;
};

export type GetContractInvoicesParams = { contractId: string };

export type GetContractInvoicesResponse = {
  contract_id: string;
  found: boolean;
  invoices: InvoiceWithState[];
  summary: ReceivablesSummary;
};

export const getContractInvoices = async ({
  contractId,
}: GetContractInvoicesParams): Promise<GetContractInvoicesResponse> => {
  const url = `/web/studio/superfunnel/contracts/${contractId}/invoices`;
  const response = await api.executeGetRequest(url, {});
  return (response.data as { data: GetContractInvoicesResponse }).data;
};
